
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class UnderwaterLightEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
        const count = Math.floor(5 * (config.parallaxComplexity || 1.0));
        const curTime = time * 0.3 * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        for (let i = 0; i < count; i++) {
            const x = (this.pseudoRandom(i) - 0.5) * width * 2;
            const w = (100 + this.pseudoRandom(i + 10) * 200) * scale;
            const sway = Math.sin(curTime + i) * 100;
            
            const draw = () => {
                const grad = ctx.createLinearGradient(x + sway, -height, x + sway + 50, height);
                grad.addColorStop(0, pc.color);
                grad.addColorStop(1, 'transparent');
                
                ctx.fillStyle = grad;
                ctx.globalAlpha *= 0.1 / layerIndex;
                ctx.beginPath();
                ctx.moveTo(x + sway - w/2, -height);
                ctx.lineTo(x + sway + w/2, -height);
                ctx.lineTo(x + sway + w, height);
                ctx.lineTo(x + sway - w, height);
                ctx.fill();
            };
            draw();
            this.applyGlow(pc, draw);
        }
    }
}
